import O1HD from "../../../../engines/gameEngine";
import { UIKind } from "../../../define/UIKind";
import NormalGameManager from "../../manager/NormalGameManager";
import normalMode from "../../normalMode";
import AccountItemNode from "./AccountItemNode";
const {ccclass, property} = cc._decorator;

/**
 * 用户账本数据
 */
@ccclass
export default class UserAccountPrefab extends cc.Component {

    @property({type:cc.Node,displayName:"中心节点"})
    center:cc.Node = null;
    @property({type:cc.Node,displayName:"内容节点"})
    contentNode : cc.Node = null;
    @property({type:cc.Prefab,displayName:"账户item预制体"})
    accountItemPrefab : cc.Prefab = null;


    private mParentScript : normalMode;

    onLoad () {
        // this.center.scale = 0.1;
        // cc.tween(this.center).to(.5,{scale:1},{ easing:cc.easing.backOut }).start();
    }

    start () {
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.BILL);
    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.BILL);
    }

    /**
     * 绑定数据
     * @param parentScript
     */
    bindData( parentScript : normalMode ){
        this.mParentScript = parentScript;
        let accountDataList = this.mParentScript.gameManager.getGameData().userAccountInfo;
        for ( let accountItemData of accountDataList ) {
            let accountItemNode = cc.instantiate( this.accountItemPrefab );
            this.contentNode.addChild( accountItemNode );
            accountItemNode.getComponent( AccountItemNode ).bindData( accountItemData , this.mParentScript );
        }
 
        //清除账单 红点记录
        this.mParentScript.gameManager.setGameData({userAccountInfoNewMsg : 0 }, false );
    }

    /**
     * 关闭
     */
    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        // cc.tween(this.center).to(.5,{scale:0},{easing:cc.easing.backIn}).call(()=>{
            this.node.destroy();
            this.node.removeFromParent();
        // }).start();
    }

}
